import { AxiosResponse } from 'axios'
import { post } from './base/base-http-service'

export const taggersProgressReportOvertimeService = async (
    payload
): Promise<AxiosResponse> => {
  return post(`taggers-daily-progress-report/custom`, payload)
}
